export default __webpack_public_path__ + "static/media/pexels-rfstudio-3825541 - Copy.fb8b5e23.jpg";